const { observeVisibility } = window.BAO.Utils
class CollectionScrollPosition {
  constructor () {
    // Last clicked item data
    this.lastClickedItemHrefKey =
      'collectionScrollPosition-lastClickedItemHref'
    this.lastClickedItemHref = sessionStorage.getItem(
      this.lastClickedItemHrefKey,
    )
    // Last visited url data
    this.lastVisitedUrlsKey =
      'collectionScrollPosition-lastVisitedCollectionUrl'
    this.lastVisitedUrls = sessionStorage.getItem(this.lastVisitedUrlsKey)
    // Last visited paginated page data
    this.lastVisitedCollectionUrlPageKey =
      'collectionScrollPosition-lastVisitedCollectionUrlPage'
    this.lastVisitedCollectionUrlPage = sessionStorage.getItem(
      this.lastVisitedCollectionUrlPageKey,
    )

    this.currentUrl = this.urlToPathName(window.location.href)

    this.initialise()
    this.setupListeners()
  }

  setupListeners () {
    // For Safari/IOS where the BF cache kind of works, but fails to scroll

    if (this.currentUrl.includes('/collections/')) {
      window.addEventListener('pageshow', () => this.restoreScrollPosition())
    }
  }

  initialise () {
    if (this.currentUrl.includes('/collections/')) {
      this.handleCollectionTemplate()
    } else if (this.currentUrl.includes('/products/')) {
      this.handleProductTemplate()
    } else {
      this.clearData()
    }
  }

  handleCollectionTemplate () {
    let previousUrls = []

    try {
      previousUrls = JSON.parse(this.lastVisitedUrls)
      if (!Array.isArray(previousUrls)) previousUrls = []
    } catch (e) {
      previousUrls = []
    }

    const lastVisited = previousUrls[previousUrls.length - 1]
    this.lastVisitedCollectionUrl = this.currentUrl

    this.updateLastVisistedUrls(this.currentUrl)

    // Disable browser's native scrollRestoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    if (lastVisited === this.currentUrl) {
      this.clearData()
    }

    this.captureScrollPosition()

    document.addEventListener('depict:ready', () => {
      this.restoreScrollPosition()
    })
  }

  handleProductTemplate () {
    this.updateLastVisistedUrls(this.currentUrl)
  }

  restoreScrollPosition () {
    // Retrieve and restore last position
    if (this.lastClickedItemHref && this.lastClickedItemHref !== 'undefined') {
      const maxTries = 20
      const scrollToElement = () => {
        // Scoped to the collection grid so we never match a same-href
        // product-card living in an unrelated carousel (Recently Viewed,
        // Complete the Look, etc.)
        const el = document.querySelector(
          `.clc-ProductGrid a[href="${this.lastClickedItemHref}"]`,
        )

        if (el) {
          const productCard = el.closest('product-card')

          requestAnimationFrame(() => {
            productCard.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            })
            el.focus?.({ preventScroll: true })
            this.clearData()
          })
        } else {
          if (!this._scrollTries) this._scrollTries = 0
          if (this._scrollTries < maxTries) {
            this._scrollTries++
            setTimeout(scrollToElement, 50)
          } else {
            // Stop trying after maxTries
            this._scrollTries = 0
          }
        }
      }

      this._scrollTries = 0
      scrollToElement()
    }
  }

  captureScrollPosition () {
    // Capture clicked item
    window.addEventListener('click', (e) => {
      const anchor = e.target.closest('a')
      const item = e.target.closest(
        '[data-collection-filters-el="item"], [data-depict-collection-el="item"]',
      )

      if (!anchor || !item) return

      e.preventDefault()

      const href = anchor.getAttribute('href')
      const page = item.getAttribute('data-page')

      sessionStorage.setItem(
        'collectionScrollPosition-lastClickedItemHref',
        href,
      )
      this.lastClickedItemHref = href

      if (page != null) {
        sessionStorage.setItem(
          'collectionScrollPosition-lastVisitedCollectionUrlPage',
          page,
        )

        const currentParams = new URLSearchParams(window.location.search)
        if (page !== '1') {
          currentParams.set('page', page)
        } else {
          currentParams.delete('page')
        }

        const newParams = currentParams.toString()
          ? `?${currentParams.toString()}`
          : ''

        const newUrl = `${window.location.pathname}${newParams}`
        history.pushState({ page }, '', newUrl)
      }

      window.location.href = href
    })

    // Capture beforeunload event
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem(
        this.lastClickedItemHrefKey,
        this.lastClickedItemHref || '',
      )
    })
  }

  updateLastVisistedUrls (url) {
    const array = this.lastVisitedUrls
      ? [...JSON.parse(this.lastVisitedUrls)]
      : []
    array.push(url)

    const lastItem = array[array.length - 1]
    const secondToLastItem = array[array.length - 2]

    if (lastItem === secondToLastItem) {
      // If the last two items are the same, we clear data
      this.clearData()
    } else if (
      lastItem?.includes('/collections/') &&
      secondToLastItem?.includes('/collections/')
    ) {
      // If the last two items are both collections, we clear data
      this.clearData()
    } else {
      sessionStorage.setItem(this.lastVisitedUrlsKey, JSON.stringify(array))
    }
  }

  clearData () {
    sessionStorage.removeItem(this.lastClickedItemHrefKey)
    sessionStorage.removeItem(this.lastVisitedUrlsKey)
    sessionStorage.removeItem(this.lastVisitedCollectionUrlPageKey)
    this.lastClickedItemHref = null
    this.lastVisitedUrls = null
    this.lastVisitedCollectionUrlPage = null
  }

  urlToPathName (url) {
    const object = new URL(url)
    return object.pathname
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.collectionScrollPosition = new CollectionScrollPosition()
})

observeVisibility('.ft-Footer', {
  target: '.clc-ProductGrid',
  className: 'clc-ProductGrid_Scrolled',
})
